
import 'three/examples/js/lines/LineSegments2';
import 'three/examples/js/lines/LineSegmentsGeometry';
import 'three/examples/js/lines/LineMaterial';

import TextSprite from '../TextSprite';

export default class SBPBoundingBox extends THREE.LineSegments2 {
  constructor (min, max, color = new THREE.Color(0x00939D), textColor = '#00939D') {
    let p0 = new THREE.Vector3(min.x, min.y, min.z);
    let p1 = new THREE.Vector3(max.x, min.y, min.z);
    let p2 = new THREE.Vector3(max.x, min.y, max.z);
    let p3 = new THREE.Vector3(min.x, min.y, max.z);
    let p4 = new THREE.Vector3(min.x, max.y, min.z);
    let p5 = new THREE.Vector3(max.x, max.y, min.z);
    let p6 = new THREE.Vector3(max.x, max.y, max.z);
    let p7 = new THREE.Vector3(min.x, max.y, max.z);

    let vertices = [
      p0, p1, p1, p2, p2, p3, p3, p0, // bottom
      p0, p4, p1, p5, p2, p6, p3, p7, // side
      p4, p5, p5, p6, p6, p7, p7, p4 // top
    ];

    let positions = [];
    vertices.forEach(v => {
      positions.push(v.x, v.y, v.z);
    });
    let geom = new THREE.LineSegmentsGeometry();
    geom.setPositions(positions);

    super(geom, new THREE.LineMaterial({
      color: color,
      transparent: true,
      opacity: 0.3,
      linewidth: 1.25
    }));

    this.min = min;
    this.max = max;
    this.size = new THREE.Vector3(
      max.x - min.x,
      max.y - min.y,
      max.z - min.z
    );
    this.corners = {
      x: new THREE.Vector3(),
      y: new THREE.Vector3(),
      z: new THREE.Vector3()
    };
    this.corners.x.copy((new THREE.Vector3()).addVectors(p0, p1).multiplyScalar(0.5));
    this.corners.y.copy((new THREE.Vector3()).addVectors(p1, p5).multiplyScalar(0.5));
    this.corners.z.copy((new THREE.Vector3()).addVectors(p1, p2).multiplyScalar(0.5));

    const textHeight = 16;
    this.x = new TextSprite(this.label(this.size.x, 'W'), textColor, textHeight);
    this.y = new TextSprite(this.label(this.size.y, 'H'), textColor, textHeight);
    this.z = new TextSprite(this.label(this.size.z, 'D'), textColor, textHeight);

    this.x.position.copy(this.corners.x);
    this.y.position.copy(this.corners.y);
    this.z.position.copy(this.corners.z);

    this.add(this.x);
    this.add(this.y);
    this.add(this.z);
  }

  resize (w, h) {
    const baseHeight = 640;
    const ratio = baseHeight / h;
    const tScale = (new THREE.Vector2(1, 1)).multiplyScalar(ratio);
    this.x.resize(tScale);
    this.y.resize(tScale);
    this.z.resize(tScale);
  }

  label (v, part = 'X') {
    return `${part}:${this.formatNumber(v)}mm`;
  }

  formatNumber(num) {
    if (Number.isInteger(num)) {
      return num.toString();
    } else {
      return num.toFixed(1);
    }
  }

  getWorldCorners () {
    let x = this.localToWorld(this.corners.x.clone());
    let y = this.localToWorld(this.corners.y.clone());
    let z = this.localToWorld(this.corners.z.clone());
    return {
      x: x,
      y: y,
      z: z
    };
  }

  setResolution (w, h) {
    this.material.uniforms.resolution.value.x = w;
    this.material.uniforms.resolution.value.y = h;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/sbp/SBPBoundingBox.js